<template>
    <div class="page" v-loading.fullscreen.lock="fullscreenLoading">
        <div style="width: 100%;display: flex;justify-content: center;" v-if="!fullscreenLoading">
            <div style="width: 65%;">
                <div  id="pdf-details">
                    <div class="pdf-details" style="display: flex;justify-content: left;align-items: center;">
                        <img style="height: 4rem;margin-right: 3rem;" src="../../../assets/logo.png">
                        <label style="font-size: 1.5rem;color: #60AB42;" v-if="booking.bookingStatus==0">{{$i18n.locale=='en'?"STATUS: Processing":"狀態：處理中"}}</label>
                        <label style="font-size: 1.5rem;color: #60AB42;" v-if="booking.bookingStatus==1">{{$i18n.locale=='en'?"STATUS: Confirmed":"狀態：已確認"}}</label>
                        <label style="font-size: 1.5rem;color: #60AB42;" v-if="booking.bookingStatus==2">{{$i18n.locale=='en'?"STATUS: Cancelled":"已取消"}}</label>
                    </div>
                    <div class="dotted pdf-details"></div>
                    <el-row class="pdf-details" :gutter="48">
                        <el-col :span="6">
                            <div>
                                <label class="key">{{$t('voucher.bookingNo')}}</label><br>
                                <label class="value">{{booking.id}}</label>
                            </div>
                        </el-col>

                        <el-col :span="6">
                            <div>
                                <label class="key">{{$t('voucher.invoiceNo')}}</label><br>
                                <label class="value">{{booking.bookingNo}}</label>
                            </div>
                        </el-col>

                        <el-col :span="6">
                            <div>
                                <label class="key">{{$t('voucher.tourCode')}}</label><br>
                                <label class="value">{{booking.trip?.tourCode}}</label>
                            </div>
                        </el-col>

                        <el-col :span="6">
                            <div>
                                <label class="key">{{$t('voucher.agentName')}}</label><br>
                                <label class="value">{{booking.account?.accountName}}</label>
                            </div>
                        </el-col>
                    </el-row>
                    <div class="dotted pdf-details"></div>
                    <div class="line pdf-details">
                        <label class="key">{{$t('voucher.tourName')}}</label>
                        <label class="value">{{booking.trip?.tourName}}</label>
                    </div>
                    <!--
                    <div class="line">
                        <label class="key">Duration</label>
                        <label class="value">{{booking.trip?.duration}}</label>
                    </div>
                    -->
                    <div class="line pdf-details">
                        <label class="key">{{$t('voucher.tourDate')}}</label>
                        <label class="value">{{booking.tourDate.split(" ")[0]}}</label>
                    </div>
                    
                    <div class="line" pdf-details v-if="booking.trip&&booking.trip?.schedulings">
                        <label class="key">{{$t('voucher.tourEndDate')}}</label>
                        <label class="value">{{getLocalDateYYYYMMDD(new Date(new Date(booking.tourDate).getTime() + (booking.trip?.schedulings.length-1) * 86400000+3602000))}}</label>
                    </div>
                    
                    <div class="line pdf-details">
                        <label class="key">{{$t('voucher.consultant')}}</label>
                        <label class="value">{{booking.consultant}}</label>
                    </div>

                    <div class="line pdf-details">
                        <label class="key">{{$t('voucher.refNo')}}</label>
                        <label class="value">{{booking.refNo}}</label>
                    </div>
                    <div class="dotted pdf-details"></div>
                    <div>
                        <h3>{{$t('voucher.travellers')}}</h3>
                    </div>
                    <el-row class="pdf-details" :gutter="48" v-for="(item,index) of booking.passengers" :key="index+10086" style="margin-bottom: 1rem;">
                        <el-col :span="6">
                            <label class="key">{{$t('voucher.name')}}</label>
                            <label class="value">{{item.lastName+"/"+item.firstName}}</label>
                        </el-col>
                        <!--
                        <el-col :span="6">
                            <label class="key">Contact</label>
                            <label class="value">{{item.contactPhoneNumber}}</label>
                        </el-col>
                        <el-col :span="6">
                            <label class="key">Email</label>
                            <label class="value">{{item.email}}</label>
                        </el-col>
                        -->
                        <el-col :span="6">
                            <label class="key">{{$t('voucher.gender')}}</label>
                            <label class="value">{{item.gender}}</label>
                        </el-col>
                    </el-row>
                    <div class="dotted pdf-details"></div>
                    <div class="pdf-details">
                        <h3>{{$t('voucher.passengerInfo')}}</h3>
                    </div>
                    <div class="line pdf-details">
                        <label class="key">{{$t('voucher.adult')}}</label>
                        <label class="value">{{booking.adultNum}}</label>
                    </div>

                    <div class="line pdf-details">
                        <label class="key">{{$t('voucher.childWithBed')}}</label>
                        <label class="value">{{booking.childWithBedNum}}</label>
                    </div>

                    <div class="line pdf-details">
                        <label class="key">{{$t('voucher.childWithoutBed')}}</label>
                        <label class="value">{{booking.childWithoutBedNum}}</label>
                    </div>

                    <!--
                    <div class="line">
                        <label class="key">Infant with Bed</label>
                        <label class="value">{{booking.infantwithBedNum}}</label>
                    </div>
                    <div class="line">
                        <label class="key">Infant without Bed</label>
                        <label class="value">{{booking.infantwithoutBedNum}}</label>
                    </div>
                    -->
                    <div class="dotted pdf-details"></div>

                    <div class="pdf-details">
                        <h3>{{$t('voucher.arrivalDetails')}}</h3>
                    </div>
                    <div class="value pdf-details">
                        <div v-for="(item,index) in booking.arrivalDetails" :key="index">
                            <label class="value">{{item.time+" "+item.adelaideAirport+" "+ item.flightNo+" ("+item.passenger?.lastName+"/"+item.passenger?.firstName+")"}}</label>
                        </div>
                    </div>
                    <div class="dotted pdf-details"></div>


                    <div class="pdf-details">
                        <h3>{{$t('voucher.departureDetails')}}</h3>
                    </div>
                    <div class="value pdf-details">

                        <div v-for="(item,index) in booking.departureDetails" :key="index">
                            <label class="value">{{item.time+" "+item.adelaideAirport+" "+ item.flightNo+" ("+item.passenger?.lastName+"/"+item.passenger?.firstName+")"}}</label>
                        </div>
                        
                    </div>
                    <div class="dotted pdf-details"></div>


                    <div class="pdf-details">
                        <h3>{{$t('voucher.noOfRooms')}}</h3>
                    </div>
                
                    <el-row :gutter="48"  class="pdf-details">
                        <el-col :span="6">
                            <label class="key">{{$t('voucher.singleRoom')}}</label>
                            <label class="value">x{{booking.singleRoom}}</label>
                        </el-col>
                        <el-col :span="6">
                            <label class="key">{{$t('voucher.twinRoom')}}</label>
                            <label class="value">x{{booking.twinRoom}}</label>
                        </el-col>
                        
                        <el-col :span="6">
                            <label class="key">{{$t('bookingTour.doubleRoom')}}</label>
                            <label class="value">x{{booking.doubleRoom}}</label>
                        </el-col>
                        
                        <el-col :span="6">
                            <label class="key">{{$t('voucher.twinRoomExtraBed')}}</label>
                            <label class="value">x{{booking.tripleRoom}}</label>
                        </el-col>
                    </el-row>
                    <div class="dotted pdf-details"></div>
                    <div class="pdf-details">
                        <h3>{{$t('voucher.tippingPrepaid')}}</h3>
                    </div>
                    <div class="value pdf-details">
                        <span v-if="booking.tippingPrepaid">{{$t('voucher.yes')}}</span>
                        <span v-if="!booking.tippingPrepaid">{{$t('voucher.no')}}</span>
                    </div>

                    <div class="dotted pdf-details"></div>
                    <div class="pdf-details">
                        <h3>{{$t('voucher.compulsoryProgramPrepaid')}}</h3>
                    </div>
                    <div class="value pdf-details">
                        <span v-if="booking.compulsoryPrepaid">{{$t('voucher.yes')}}</span>
                        <span v-if="!booking.compulsoryPrepaid">{{$t('voucher.no')}}</span>
                    </div>

                    <div class="dotted pdf-details"></div>
                    <div class="pdf-details">
                        <h3>{{$t('voucher.extraItemDescription')}}</h3>
                    </div>
                    <div class="value pdf-details">
                        <template v-if="booking.extraFees && booking.extraFees.length">
                            <div v-for="(fee, index) in booking.extraFees" :key="index">
                                <span>{{ fee.description }}</span>
                                
                            </div>
                        </template>
                        <span v-else>{{booking.extraItemDescription}}</span>
                    </div>

                    <div class="dotted pdf-details"></div>
                    <div class="pdf-details">
                        <h3>{{$t('voucher.pickupPoint')}}</h3>
                    </div>
                    <div class="value pdf-details" v-html="booking.trip?.pickupPoint"></div>

                    <div class="pdf-details">
                        <h3>{{$t('voucher.warmTips')}}</h3>
                    </div>
                    <div class="value pdf-details">1、參團期間請客人攜戴有效證件：比如美國/加拿大/澳洲護照或綠卡/楓葉卡/PR證明（原件）；如參團期間無法出示有效證件則不能享有當地優惠政策，本公司導遊會向客人收取原價參團費用。<br>
2、報名證件如有換新請及時通知，如因證件號碼錯誤或沒有提前更新而導致無法入內參觀主要景區或無法搭乘行程內陸交通（包括高鐵/船/機票）等，請客人自付損失費用。</div>

                    <div class="dotted pdf-details"></div>
                    <div  class="pdf-details">
                        <h3>{{$t('voucher.tourGuide')}}</h3>
                    </div>
                    <div class="value pdf-details" v-html="booking.tourGuide"></div>

                    <div class="dotted pdf-details"></div>
                    <div class="pdf-details">
                        <h3>{{$t('voucher.remark')}}</h3>
                    </div>
                    <div class="value pdf-details" v-html="booking.trip?.remark"></div>


                    <div class="dotted pdf-details"></div>
                    <div class="pdf-details">
                        <h3>{{$t('bookingSummary.preHotel')}}</h3>
                    </div>
                    <div class="value pdf-details">
                        <div v-for="(item,index) in booking.preTourAccommodations" :key="index">
                            <label class="value">{{item.nights+"Nights/"+item.roomType+"/"+" ("+item.passenger?.lastName+"/"+item.passenger?.firstName+")"}}</label>
                        </div>
                    </div>


                    <div class="dotted pdf-details"></div>
                    <div class="pdf-details">
                        <h3>{{$t('bookingSummary.postHotel')}}</h3>
                    </div>
                    <div class="value pdf-details">
                        <div v-for="(item,index) in booking.postTourAccommodations" :key="index">
                            <label class="value">{{item.nights+"Nights/"+item.roomType+"/"+" ("+item.passenger?.lastName+"/"+item.passenger?.firstName+")"}}</label>
                        </div>
                    </div>


                    

                    <div class="dotted pdf-details"></div>
                    <div class="pdf-details">
                        <h3>{{$t('voucher.scheduling')}}</h3>
                    </div>
                    
                    <div class="pdf-details" style="margin-bottom: 2rem;" v-for="(item) of booking.trip?.schedulings" :key="item.sort">
                        <div style="color: #167D5B;font-size: 1.4rem;margin-bottom: 0.5rem;font-weight: 500;">{{ item.sort+". "+item.title+" "+getLocalDateYYYYMMDD(new Date(new Date(booking.tourDate).getTime() + (item.sort-1)*86400000+3602000),item.sort)}}</div>
                        <div style="color:#000000;font-size: 1.4rem;" v-html="item.content"></div>
                        <!--<div style="color:#000000;font-size: 1.4rem;" >{{ item.content }}</div>-->
                    </div>
                    
                    <div class="dotted pdf-details"></div>
                    <!--
                    <div>
                        <h3>Notice</h3>
                    </div>
                    <div class="value" v-html="booking.trip?.notice"></div>
                    <div class="dotted"></div>
                    -->
                </div>

                <div style="text-align: center;margin-top: 1rem;">
                    <div>
                        <el-input style="margin-right: 1rem;width: 20rem;" v-model="emailAddress" placeholder="请输入邮箱"></el-input>
                        <el-button style="margin-right: 5rem;" type="primary" @click="sendEmailClick" :loading="sendingEmail">发送</el-button>
                        <el-button type="primary" @click="downloadPDFClick">{{$t('voucher.downloadPDF')}}</el-button>
                    </div>
                    
                    
                </div>
            </div>
            
        </div>
        
    </div>
  </template>
  
  <script>
  import {htmlPdf,getHtmlPdf} from '@/service/pdf';
  export default {
    props:{BookingId:null},
    name: 'voucher-page',
    data(){
        return {
            emailAddress:'',
            booking:new Object(),
            fullscreenLoading:true,
            sendingEmail:false
        }
    },
    mounted(){
        this.getBookingDetails(this.BookingId);
    },
    methods:{
        getLocalDateYYYYMMDD(date = new Date(),sort) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            console.log("Sort",sort);
            return `${year}-${month}-${day}`;
        },
        getBookingDetails(id){
            this.fullscreenLoading=true;
            let that = this;
            this.$httpservice.get('api/Booking/Get',{id:id}).then(result => {
                this.fullscreenLoading=false;
                if(result.status==200){
                    if(result.body.code=='200'){
                        that.booking = result.body.data;
                        
                    }else{
                        that.$message({
                                message: 'Get Booking info Failed',
                                type: 'warning'
                        });
                    }
                }
            });
        },
        downloadPDFClick(){
            const lableList = document.getElementsByClassName('pdf-details');
            htmlPdf("#"+this.booking.id+"-voucher-"+this.booking.tourDate.split(' ')[0]+'-'+this.booking.trip.tourCode, document.querySelector('#pdf-details'),lableList);
        },
        sendEmailClick(){
            const email = (this.emailAddress || '').toString().trim();
            if(!email){
                this.$message({ message: 'Please enter an email address', type: 'warning' });
                return;
            }
            // Simple email regex: non-whitespace before and after @ and a dot in domain
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if(!emailRegex.test(email)){
                this.$message({ message: 'Please enter a valid email address', type: 'warning' });
                return;
            }

            this.sendEmail(email);
        },

        async sendEmail(email){
            try{
                
                const htmlEl = document.querySelector('#pdf-details');
                if(!htmlEl){
                    this.$message({ message: 'PDF element not found', type: 'warning' });
                    return;
                }

                const lableList = document.getElementsByClassName('pdf-details');

                // Pass the same args as downloadPDFClick so getHtmlPdf receives valid inputs
                const blob = await getHtmlPdf('Voucher', htmlEl, lableList);

                if(!blob){
                    this.$message({ message: 'Failed to generate PDF', type: 'warning' });
                    return;
                }

                let formData = new FormData();
                console.log("Generated PDF blob:", blob);

                formData.append("title", 'no- reply  #'+this.booking.id+' voucher-'+this.booking.tourDate.split(' ')[0]+' '+this.booking.trip.tourName);
                let emailBody = `------------<br><br>Fun Trip Holiday INC bank as below:<br>company account: Fun Trip Holiday INC<br>zelle payment: 646-492-0649<br>CapitalOne Bank account number：5734207720<br>Routing number 06500090<br>Chase bank account number: 590530286<br>Routing number: 021000021<br><br>Best regards,<br>Fun Trip Holiday 趣旅游<br>Tel: 646-492-0649<br>Email：booking@funtripholidayus.com`;
                if(this.booking.tourGuide){
                    emailBody = this.booking.tourGuide+'<br><br>'+emailBody;
                }
                formData.append('body',emailBody);
                formData.append('receiver',email);
                formData.append("file", blob, "#"+this.booking.id+"-voucher-"+this.booking.tourDate.split(' ')[0]+'-'+this.booking.trip.tourCode+".pdf");
                this.sendingEmail=true;
                this.$httpservice.post('api/Common/SendEmail',formData).then(result => {
                    this.sendingEmail=false;
                    if(result.status==200){
                        if(result.body.code=='200'){
                            this.$message({ message: 'Email sent successfully', type: 'success' });
                        }else{
                            this.$message({ message: 'Email sent failed', type: 'warning' });
                        }
                    }
                }).catch(err => {
                    this.sendingEmail=false;
                    console.error(err);
                    this.$message({ message: 'Send email request failed', type: 'error' });
                });
            }catch(err){
                console.error(err);
                this.$message({ message: 'Error generating or sending PDF: ' + (err && err.message ? err.message : err), type: 'error' });
            }
        }
    }
   
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
    .page{
        padding: 1rem;

        .dotted {
            margin-top: 1rem;
            margin-bottom: 2rem;
            border-bottom: 1px dotted #000;
            width: 100%;
        }
        .key{
            color: black;margin-right: 1rem;font-size: 1.3rem;font-weight: bold;
        }
        .value{
            //color:#999999;font-size: 1rem;
            color:#000000;font-size: 1.3rem;
        }
        .line{
            margin-top: 1.2rem;
            margin-bottom: 1rem;
        }
    }
  </style>
  